export default __webpack_public_path__ + "static/media/location_w.16d357f6.svg";